export default __webpack_public_path__ + "static/media/S0020_6.9_IIMARCH.1702919220000.72d4a386.jpg";